exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-how-to-deal-FAjtO .index-head-2irkq{font-weight:700}.index-how-to-deal-FAjtO .index-answer-3BY96{font-size:12px;margin:10px 0;color:#666}.index-how-to-deal-FAjtO .index-answer-3BY96 .index-highlight-3xP9O{color:#1e6fff;color:var(--accent-default,#1e6fff);font-weight:700}.index-how-to-deal-FAjtO .index-item-3o_7g{margin:10px 0}.index-how-to-deal-FAjtO .index-item-3o_7g .index-explain-3ghUC{position:relative;font-size:12px;font-weight:700;line-height:12px;margin-bottom:10px;padding-left:8px}.index-how-to-deal-FAjtO .index-item-3o_7g .index-explain-3ghUC:before{position:absolute;content:\"\";display:inline-block;width:2px;height:12px;left:0;background-color:#1e6fff;background-color:var(--accent-default,#1e6fff)}", ""]);

// Exports
exports.locals = {
	"how-to-deal": "index-how-to-deal-FAjtO",
	"head": "index-head-2irkq",
	"answer": "index-answer-3BY96",
	"highlight": "index-highlight-3xP9O",
	"item": "index-item-3o_7g",
	"explain": "index-explain-3ghUC"
};